import { DataType } from '../DataType';
import { FFuncType } from './FormulaFunc';
export class FExprBase {
    constructor(returnType) {
        this._returnType = returnType;
    }
    get returnType() {
        return this._returnType;
    }
}
export class FExprScalar extends FExprBase {
    constructor(returnType, values) {
        super(returnType);
        this._value = (scope) => {
            for (let i = 0; i < values.length; i++) {
                const val = values[i](scope);
                // optimized workaround for booleans being marked as strings
                // see: https://app.asana.com/0/535138853563887/561854409823141
                if (this.returnType === DataType.STRING && typeof val === 'boolean') {
                    return val ? 'true' : 'false';
                }
                return val;
            }
        };
    }
    get type() {
        return FFuncType.SCALAR;
    }
    get value() {
        return this._value;
    }
}
export class FExprAgg extends FExprBase {
    constructor(returnType, inits, steps, finals) {
        super(returnType);
        this._init = (scope) => {
            for (let i = 0; i < inits.length; i++) {
                inits[i](scope);
            }
        };
        this._step = (scope) => {
            for (let s = 0; s < steps.length; s++) {
                steps[s](scope);
            }
        };
        this._final = (scope) => {
            for (let f = 0; f < finals.length; f++) {
                return finals[f](scope);
            }
        };
    }
    get type() {
        return FFuncType.AGG;
    }
    get init() {
        return this._init;
    }
    get step() {
        return this._step;
    }
    get final() {
        return this._final;
    }
}
